<template>
  <div
    v-if="show"
    class="flex items-center text-[14px] leading-[18px] font-medium"
  >
    <template v-if="checking">
      <Spinner :size="12" class="mr-1.5" />
      <div>Checking availability</div>
    </template>
    <template v-else-if="available">
      <CheckedSolidIcon class="size-3.5 mr-1.5 text-green-900" />
      <div class="text-green-900">Username available</div>
    </template>
    <template v-else>
      <AlertIcon class="size-3.5 mr-1.5 text-red-700" />
      <div class="text-red-700">Username not available</div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { CheckedSolidIcon, AlertIcon } from '@dacr/icons'
import Spinner from '@/shared/components/Spinner.vue'

defineProps<{
  show: boolean
  checking: boolean
  available: boolean
}>()
</script>
